import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { awards } from "@/mocks/ppcare";

export default function AwardsSection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="container">
        <Reveal>
          <SectionHeading
            eyebrow="Awards and Accreditation"
            title={
              <>
                PPCare is a Family Owned <span className="text-accent-500">Practice</span>
              </>
            }
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-2 gap-6 lg:grid-cols-4">
          {awards.map((award, index) => (
            <Reveal key={award.name} delay={index * 80}>
              <div className="flex h-40 items-center justify-center rounded-lg border border-background-200 bg-background-100 p-6">
                <img
                  src={award.image}
                  alt={award.name}
                  className="max-h-28 w-auto max-w-full object-contain"
                />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}